import script from "./ProfileParentRemoveModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileParentRemoveModal.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileParentRemoveModal.vue?vue&type=style&index=0&id=56e79ac8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56e79ac8"]])

export default __exports__